import AddIcon from '@mui/icons-material/Add'
import RemoveIcon from '@mui/icons-material/Remove'
import { Box, Button } from '@mui/material'

type CounterProps = {
  negativeOnClick: (newValue: number) => void
  negativeDisabled?: boolean
  negativeVisible?: boolean
  positiveOnClick: (newValue: number) => void
  positiveDisabled?: boolean
  positiveVisible?: boolean
  value: number
  label: string
  btnMargin?: string
}

const Counter = ({
  negativeOnClick,
  negativeDisabled = false,
  negativeVisible = true,
  positiveOnClick,
  positiveDisabled = false,
  positiveVisible = true,
  value,
  label,
  btnMargin = undefined,
}: CounterProps) => {
  const margin = btnMargin ? { margin: btnMargin } : {}
  return (
    <Box sx={{ minWidth: '200px' }}>
      <Box
        component="div"
        sx={{
          display: 'flex',
          flexDirection: 'row',
          gap: '8px',
          justifyContent: 'space-between',
          alignItems: 'center',
        }}
      >
        {negativeVisible && (
          <Button
            sx={{
              padding: '10px',
              background: '#fff',
              border: '1px solid var(--jy-navy-900, #00253d)',
              width: '40px',
              height: '40px',
              '&:hover,&:focus': {
                background: '#fff',
                border: '1px solid var(--jy-navy-900, #00253d)',
                color: 'var(--jy-navy-900, #00253d)',
              },
              ...margin,
            }}
            onClick={() => negativeOnClick(Math.max(value - 1, 0))}
            disabled={negativeDisabled}
          >
            <RemoveIcon
              sx={{ color: 'var(--jy-navy-900, #00253d)', marginRight: '0px !important' }}
            />
          </Button>
        )}
        <Box
          component="div"
          sx={{
            display: 'flex',
            flexDirection: 'row',
            gap: '5px',
            justifyContent: 'flex-start',
            alignItems: 'center',
            fontSize: '18px',
          }}
        >
          <Box
            component="span"
            sx={
              label
                ? { fontWeight: '400', color: '#414042' }
                : {
                    width: '40px',
                    height: '40px',
                    display: 'flex',
                    justifyContent: 'center',
                    alignItems: 'center',
                    background: '#F7F7F7',
                    borderRadius: '4px',
                  }
            }
          >
            {value}
          </Box>
          {label && (
            <Box
              component="span"
              sx={{ fontWeight: 'light', color: '#302f31' }}
            >
              {value === 1 ? label : `${label}s`}
            </Box>
          )}
        </Box>
        {positiveVisible && (
          <Button
            sx={{
              padding: '10px',
              background: '#fff',
              border: '1px solid var(--jy-navy-900, #00253d)',
              width: '40px',
              height: '40px',
              color: 'var(--jy-navy-900, #00253d)',
              ...margin,
              '&:hover,&:focus': {
                background: '#fff',
                border: '1px solid var(--jy-navy-900, #00253d)',
                color: 'var(--jy-navy-900, #00253d)',
              },
            }}
            onClick={() => positiveOnClick(value + 1)}
            disabled={positiveDisabled}
          >
            <AddIcon sx={{ marginRight: '0px !important' }} />
          </Button>
        )}
      </Box>
    </Box>
  )
}

export default Counter
